<template>
    <TitleBar
        :action="''"
        :actionPath="''"
        :app="'Courses'"
        :icon="'chalkboard'"
        :moduleTitle="'moduleTitle'"
        :resourceTitle="'resourceTitle'"
        :searchable="[]"
        :showGlobalSearch="true"
        :section="''"
        :sectionPath="''"
        :showBilling="false"
        :impersonating="false"
    />
</template>

<script lang="ts">
import { mapState } from "vuex";

export default {
    props: {},
    computed: {
        ...mapState(["activePath", "user"]),
    },
    methods: {},
};
</script>
